import { Auth } from "../Auth/Auth.js";
const auth = new Auth();
window.auth = auth;

import { Ajax } from "../Ajax/Ajax.js";
var ajax = new Ajax();
window.ajax = ajax;

import { VROC } from '../_VROC/VROC.js';
import { popupManager } from '../_VROC/PopupManager.js';

const vroc = new VROC();
window.vroc = vroc;
window.popupManager = popupManager;

import { ServiceManager } from "../CRM/Orders/ServiceManager.js";
var serviceManager = new ServiceManager();
window.serviceManager = serviceManager;

import { GuestsManager } from "../CRM/Orders/GuestsManager.js";

// Инициализируем менеджер гостей с ID заказа
// Можно получить ID из URL или других источников
const invoiceId = getInvoiceIdFromPage(); // Функция для получения ID заказа
var guestsManager = new GuestsManager(invoiceId);
window.guestsManager = guestsManager;

// Импорты компонентов
import { Excursions } from "../CRM/Excursions/Excursions.js";
import { Transfers } from "../CRM/Transfers/Transfers.js";
import { Hotels } from "../CRM/Hotels/Hotels.js";
import { Order } from "../CRM/Orders/Order.js";
import { Dashboard } from "../CRM/Dashboard/Dashboard.js";
import { VisasApplications } from "../CRM/Visas-applications/Visas-applications.js";
import { Visa } from "../CRM/Visa/Visa.js";

import { CIP } from "../CRM/CIP/CIP.js";
var cip = new CIP();
window.cip = cip;

// Функция для условной инициализации компонентов
function initPageSpecificComponents() {
	const currentUrl = window.location.pathname;

	// Определяем тип страницы по URL
	const isTransferPage = currentUrl.includes('/transfer');
	const isExcursionsPage = currentUrl.includes('/excursions') || currentUrl.includes('/experience');
	const isHotelsPage = currentUrl.includes('/hotels') || currentUrl.includes('/accommodations');
	const isOrderPage = currentUrl.includes('/crm/') && (window.location.search.includes('id=') || document.querySelector('.page.order'));
	const isDashboardPage = currentUrl.includes('/dashboard/');
	const isVisasPage = currentUrl.includes('/visa/form/') && document.querySelector('.visas-applications');
	const isVisaCheckPage = (currentUrl.includes('/visa/check') || currentUrl.includes('/visa/vftf')) && document.querySelector('.visa-check');

	console.log('[App] Current URL:', currentUrl);
	console.log('[App] Is transfer page:', isTransferPage);
	console.log('[App] Is excursions page:', isExcursionsPage);
	console.log('[App] Is hotels page:', isHotelsPage);
	console.log('[App] Is order page:', isOrderPage);
	console.log('[App] Is visas page:', isVisasPage);
	console.log('[App] Is visa check page:', isVisaCheckPage);

	// Инициализируем только нужный компонент в зависимости от страницы
	if (isExcursionsPage && document.querySelector('.excursions__content')) {
		let excursions = new Excursions();
		window.excursions = excursions;
		excursions.init();
		console.log('[App] Excursions component initialized');
	}

	if (isTransferPage && document.querySelector('.transfers__content')) {
		let transfers = new Transfers();
		window.transfers = transfers;
		transfers.init();
		console.log('[App] Transfers component initialized');
	}

	if (isHotelsPage && document.querySelector('.hotels__content')) {
		let hotels = new Hotels();
		window.hotels = hotels;
		hotels.init();
		console.log('[App] Hotels component initialized');
	}

	if (isOrderPage && document.querySelector('.page.order')) {
		let order = new Order();
		window.order = order;
		order.init();
		console.log('[App] Order component initialized');
	}

	if (isDashboardPage) {
		let dashboard = new Dashboard();
		window.dashboard = dashboard;
		console.log('[App] Dashboard component initialized');
	}

	if (isVisasPage) {
		let visasApplications = new VisasApplications(ajax);
		window.visasApplications = visasApplications;
		console.log('[App] VisasApplications component initialized');
	}

	if (isVisaCheckPage) {
		let visa = new Visa();
		window.visa = visa;
		console.log('[App] Visa component initialized');
	}
}



// Функция для получения ID заказа со страницы
function getInvoiceIdFromPage() {
	// Вариант 1: Из URL
	const urlParams = new URLSearchParams(window.location.search);
	const idFromUrl = urlParams.get('id');
	if (idFromUrl) return parseInt(idFromUrl);

	// Вариант 2: Из data-атрибута
	const dataElement = document.querySelector('[data-invoice-id]');
	if (dataElement) {
		const idFromData = dataElement.getAttribute('data-invoice-id');
		if (idFromData) return parseInt(idFromData);
	}

	// Вариант 3: Из скрытого поля
	const hiddenInput = document.querySelector('input[name="invoice_id"]');
	if (hiddenInput && hiddenInput.value) return parseInt(hiddenInput.value);

	// Вариант 3: Из скрытого поля
	const orderIdElement = document.querySelector('#orderId');
	if (orderIdElement && orderIdElement.value) return parseInt(orderIdElement.value);

	// Вариант 4: Из глобальной переменной
	if (window.currentInvoiceId) return window.currentInvoiceId;

	// По умолчанию возвращаем null или 0
	return null;
}

import { CRM } from "../CRM/CRM.js";

let crm = new CRM();
window.crm = crm;
crm.init();

import { Profile } from "../CRM/Profile/Profile.js";
let profile = new Profile();
window.profile = profile;

/* === Utilities === */
const doc = document.documentElement;

function setAppSizes() {
	const windowHeight = window.innerHeight;
	doc.style.setProperty('--app-height', `${windowHeight}px`);
	const header = document.querySelector('.header');
	if (header) doc.style.setProperty('--header-height', `${header.offsetHeight}px`);
	const crmHeader = document.querySelector('.crm-header');
	if (crmHeader) doc.style.setProperty('--crm-header-height', `${crmHeader.offsetHeight}px`);
}

function applyTouchClass() {
	const isTouch = 'ontouchstart' in window
		|| navigator.maxTouchPoints > 0
		|| navigator.msMaxTouchPoints > 0;
	document.body.classList.toggle('mob', isTouch);
	document.body.classList.toggle('des', !isTouch);
}

/* === Cookie Policy === */
function initCookiePolicy() {
	const policy = document.querySelector('.cookie');
	if (!policy || typeof cookie === 'undefined') return;
	const acceptBtn = policy.querySelector('.cookie__main-button');
	if (!acceptBtn) return;

	if (!cookie.get('cookie_notice_accepted')) {
		policy.classList.add('active');
	}

	acceptBtn.addEventListener('click', () => {
		if (!cookie.get('cookie_notice_accepted')) {
			const d = new Date();
			d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
			cookie.set('cookie_notice_accepted', 'true', { path: '/', expires: d });
		}
		policy.classList.remove('active');
		setTimeout(() => policy.remove(), 400);
	});
}


/* === Header Navigation === */
function initHeaderNav() {
	const burger = document.querySelector('.main-nav__burger');
	const mobileNav = document.querySelector('.header__mob-nav');
	const sectionLinks = Array.from(document.querySelectorAll('.main-nav__link[data-section-nav-open]'));
	const sections = Array.from(document.querySelectorAll('.header-section-nav'));
	const closeBtns = Array.from(document.querySelectorAll('.header-section-nav__close'));

	function resetAll() {
		burger?.classList.remove('active');
		mobileNav?.classList.remove('active');
		sections.forEach(s => s.classList.remove('active'));
		sectionLinks.forEach(l => l.classList.remove('active'));
		document.body.classList.remove('no-scroll');
	}
	function isMobile() {
		return window.innerWidth < 1024;
	}

	if (burger && mobileNav) {
		burger.addEventListener('click', () => {
			const willOpen = !burger.classList.contains('active');
			if (willOpen) {
				burger.classList.add('active');
				mobileNav.classList.add('active');
				document.body.classList.add('no-scroll');
			} else {
				resetAll();
			}
		});
	}

	sectionLinks.forEach(link => {
		link.addEventListener('click', e => {
			e.preventDefault();
			const key = link.getAttribute('data-section-nav-open');
			if (!key) return;
			const target = document.querySelector(`.header-section-nav[data-section-nav="${key}"]`);
			if (!target) return;

			const isOpen = target.classList.toggle('active');
			sectionLinks.forEach(l => {
				const match = l.getAttribute('data-section-nav-open') === key;
				l.classList.toggle('active', match && isOpen);
			});
			sections.forEach(s => { if (s !== target) s.classList.remove('active'); });

			if (!isMobile()) {
				document.body.classList.toggle('no-scroll', isOpen);
			}
		});
	});

	closeBtns.forEach(btn => {
		btn.addEventListener('click', () => {
			const block = btn.closest('.header-section-nav');
			if (!block) return;
			const key = block.getAttribute('data-section-nav');
			block.classList.remove('active');
			sectionLinks.forEach(l => {
				if (l.getAttribute('data-section-nav-open') === key) {
					l.classList.remove('active');
				}
			});
			if (!isMobile() && !sections.some(s => s.classList.contains('active'))) {
				document.body.classList.remove('no-scroll');
			}
		});
	});

	let wasMobile = isMobile();
	window.addEventListener('resize', () => {
		const nowMobile = isMobile();
		if (nowMobile !== wasMobile) {
			resetAll();
			wasMobile = nowMobile;
		}
	});
}

/* === Live Clock === */
function initClock() {
	let clock = document.querySelector('.header__time');
	let clockFooter = null;
	let clockNav = null;

	if (clock) {
		clockFooter = document.querySelector('.footer-contacts__block-content--time');
		clockNav = document.querySelector('.header-section-nav__time-value');
	}
	else {
		clock = document.querySelector('.crm-header__time');
		if (!clock)
			return;

		clockNav = document.querySelector('.crm-header__time');
		clockFooter = null;
	}

	function tick() {
		let [h, m] = clock.textContent.trim().split(':').map(Number);
		m = (m + 1) % 60;
		h = m === 0 ? (h + 1) % 24 : h;
		const formatted = `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
		clock.textContent = formatted;
		if (clockFooter) clockFooter.textContent = formatted;
		if (clockNav) clockNav.textContent = formatted;
	}

	setInterval(tick, 60000);
}

/* === CRM Header Menu === */
function initCRMNav() {
	const burger = document.querySelector('.crm-header__nav-burger');
	const menu = document.querySelector('.crm-main-nav');
	if (!burger || !menu) return;

	function toggle() {
		burger.classList.toggle('active');
		menu.classList.toggle('active');
	}
	function reset() {
		if (window.innerWidth >= 1024) {
			burger.classList.remove('active');
			menu.classList.remove('active');
		}
	}

	burger.addEventListener('click', toggle);
	window.addEventListener('resize', reset);
	reset();
}

/* === Cart Sidebar === */
function initCartMenu() {
	const toggler = document.querySelector('.crm-header__cart-toggler');
	const sidebar = document.querySelector('.page-order');
	const closeBtn = document.querySelector('.page-order__close');
	if (!toggler || !sidebar) return;

	toggler.addEventListener('click', () => {
		toggler.classList.toggle('active');
		sidebar.classList.toggle('active');
	});
	closeBtn?.addEventListener('click', () => {
		toggler.classList.remove('active');
		sidebar.classList.remove('active');
	});

	function reset() {
		if (window.innerWidth >= 1024) {
			toggler.classList.remove('active');
			sidebar.classList.remove('active');
		}
	}
	window.addEventListener('resize', reset);
	reset();
}

/* === Универсальные табы с поддержкой дубликатов кнопок === */
function initTabs() {
	document.querySelectorAll('.tabs').forEach(container => {
		const btns = Array.from(container.querySelectorAll('.tabs__nav-btn'));
		const panes = Array.from(container.querySelectorAll('.tabs__tab'));
		if (!btns.length || !panes.length) return;

		btns.forEach(btn => {
			btn.addEventListener('click', () => {
				const key = btn.getAttribute('data-tab');
				// 1) Сбросим у всех кнопок и табов активный класс
				btns.forEach(b => b.classList.remove('active'));
				panes.forEach(p => p.classList.remove('active'));

				// 2) Поставим active всем кнопкам с этим ключом
				container
					.querySelectorAll(`.tabs__nav-btn[data-tab="${key}"]`)
					.forEach(b => b.classList.add('active'));

				// 3) И всем табам с этим же ключом
				container
					.querySelectorAll(`.tabs__tab[data-tab="${key}"]`)
					.forEach(p => p.classList.add('active'));
			});
		});
	});
}

// Запускаем инициализацию после загрузки DOM
document.addEventListener('DOMContentLoaded', initTabs);

/* === Number Dropdown on Order Page === */
function initNumberDropdown() {
	const mainBtn = document.querySelector('.page-order__number-main');
	const menu = document.querySelector('.page-order__number-other');
	if (!mainBtn || !menu) return;

	function close() {
		mainBtn.classList.remove('active');
		menu.classList.remove('active');
	}

	mainBtn.addEventListener('click', () => {
		mainBtn.classList.toggle('active');
		menu.classList.toggle('active');
	});
	document.addEventListener('click', e => {
		if (!mainBtn.contains(e.target) && !menu.contains(e.target)) {
			close();
		}
	});
}

/* === Hotel & Room Cards === */
function initHotelAndRoomCards(container = document) {
	// Инициализация карточек отелей
	container.querySelectorAll('.hotel-card').forEach(card => {
		// Проверяем, не инициализирована ли уже эта карточка
		if (card.hasAttribute('data-hotel-card-initialized')) {
			return;
		}

		// Помечаем карточку как инициализированную
		card.setAttribute('data-hotel-card-initialized', 'true');

		// Добавляем обработчик клика
		card.addEventListener('click', e => {
			if (e.target.closest('.hotel-card__presentation, .hotel-card__rooms')) return;
			card.classList.toggle('active');
		});
	});

	// Инициализация карточек номеров
	container.querySelectorAll('.room-card').forEach(card => {
		// Проверяем, не инициализирована ли уже эта карточка
		if (card.hasAttribute('data-room-card-initialized')) {
			return;
		}

		// Помечаем карточку как инициализированную
		card.setAttribute('data-room-card-initialized', 'true');

		// Добавляем обработчик клика
		card.addEventListener('click', e => {
			if (e.target.closest('.room-card__settings-item, .room-card__nav, .room-card__image-container')) return;
			card.classList.toggle('active');
		});
	});
}

/* === Datepicker Initialization === */
function initDatepickers(container = document) {
	const fmtMonthRU_SG = new Intl.DateTimeFormat('ru', {
		month: 'long',
		timeZone: 'Asia/Singapore'
	});
	const fmtHeaderRU_SG = new Intl.DateTimeFormat('ru', {
		day: 'numeric',
		month: 'short',
		year: 'numeric',
		timeZone: 'Asia/Singapore'
	});
	function toSingaporeDateString(date) {
		if (!date) return '';
		return date.toLocaleDateString('ru-RU', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
			timeZone: 'Asia/Singapore'
		});
	}

	// click outside → close
	container.addEventListener('click', e => {
		container.querySelectorAll('.datepicker').forEach(picker => {
			const cal = picker.querySelector('.datepicker__calendar');
			if (!cal.classList.contains('active')) return;
			const tgt = e.target;
			const isToggler = !!tgt.closest('.datepicker__main-item-btn');
			const isReset = !!tgt.closest('.datepicker__main-item-reset');
			const isCal = !!tgt.closest('.datepicker__calendar');
			if (!isToggler && !isReset && !isCal) cal.classList.remove('active');
		});
	});

	container.querySelectorAll('.datepicker').forEach(picker => {
		const calendar = picker.querySelector('.datepicker__calendar');
		const monthList = picker.querySelector('.datepicker-calendar__month-list');
		const btnShowMore = picker.querySelector('.datepicker__show-more-btn');
		const btnStart = picker.querySelector('.datepicker__start-item-btn');
		const btnEnd = picker.querySelector('.datepicker__end-item-btn');
		const valStartEl = picker.querySelector('.datepicker__start-item .datepicker__main-item-value');
		const valEndEl = picker.querySelector('.datepicker__end-item .datepicker__main-item-value');
		const valInputEl = picker.querySelector('.datepicker__value');
		const nightsEl = picker.querySelector('.datepicker__main-nights');
		const nightsValueEl = picker.querySelector('.datepicker__main-nights-value');
		const resetStart = picker.querySelector('.datepicker__start-item-reset');
		const resetEnd = picker.querySelector('.datepicker__end-item-reset');

		const type = picker.dataset.datepickerType;       // "single" | "range"
		const placeholderStart = btnStart?.dataset.btnPlaceholder || '';
		const placeholderEnd = btnEnd?.dataset.btnPlaceholder || '';

		// Проверка data-required атрибута
		// ВАЖНО: не добавляем required на скрытый input, так как используем кастомную валидацию
		// if (picker.dataset.required === 'true' && valInputEl) {
		// 	valInputEl.setAttribute('required', 'required');
		// }

		let renderedCount = 0;
		let startDate = parseDataAttr('datepickerDateStart');
		let endDate = type === 'range' ? parseDataAttr('datepickerDateEnd') : null;

		function parseDataAttr(attr) {
			const v = picker.dataset[attr];
			if (!v) return null;
			const [d, m, y] = v.split('.').map(Number);
			return new Date(y, m - 1, d);
		}

		function syncDataAttrs() {
			if (startDate) picker.dataset.datepickerDateStart = toSingaporeDateString(startDate);
			else delete picker.dataset.datepickerDateStart;
			if (type === 'range') {
				if (endDate) picker.dataset.datepickerDateEnd = toSingaporeDateString(endDate);
				else delete picker.dataset.datepickerDateEnd;
			}
		}

		function renderMonths(count) {
			const today = new Date();
			for (let i = 0; i < count; i++) {
				const idx = renderedCount + i;
				const firstOfMonth = new Date(today.getFullYear(), today.getMonth() + idx, 1);
				const year = firstOfMonth.getFullYear();
				const mon = firstOfMonth.getMonth();
				let title = fmtMonthRU_SG.format(firstOfMonth);
				title = title[0].toUpperCase() + title.slice(1) + ' ' + year;

				const leadEmpty = (firstOfMonth.getDay() + 6) % 7;
				const daysInMonth = new Date(year, mon + 1, 0).getDate();

				const li = document.createElement('li');
				li.className = 'datepicker-calendar__month';
				li.dataset.year = year;
				li.dataset.month = mon;
				li.innerHTML = `
          <div class="datepicker-calendar__month-title">${title}</div>
          <div class="datepicker-calendar__month-grid">
            ${'<div class="datepicker-calendar__day-cell"></div>'.repeat(leadEmpty)}
            ${Array.from({ length: daysInMonth }, (_, k) => `
              <div class="datepicker-calendar__day-cell">
                <button class="datepicker-calendar__day-btn" type="button" value="${k + 1}">
                  ${k + 1}
                </button>
              </div>
            `).join('')}
          </div>`;
				monthList.appendChild(li);
			}
			renderedCount += count;
			attachDayHandlers();
			updateRangeClasses();
		}

		function attachDayHandlers() {
			monthList.querySelectorAll('.datepicker-calendar__day-btn').forEach(btn => {
				btn.removeEventListener('click', onDayClick);
				btn.addEventListener('click', onDayClick);
			});
		}

		function dateFromBtn(btn) {
			const day = +btn.value;
			const monthEl = btn.closest('.datepicker-calendar__month');
			return new Date(+monthEl.dataset.year, +monthEl.dataset.month, day);
		}

		function onDayClick(e) {
			const clicked = dateFromBtn(e.currentTarget);
			if (type === 'single') {
				startDate = clicked;
				endDate = null;
			} else {
				if (!startDate || (startDate && endDate)) {
					startDate = clicked;
					endDate = null;
				} else {
					clicked < startDate ? startDate = clicked : endDate = clicked;
				}
			}
			syncDataAttrs();
			updateRangeClasses();
			updateHeaderValues();

			// Триггерим событие change для всех datepicker'ов (кроме hotels, у которых своя логика)
			if (!picker.classList.contains('hotels-settings-datepicker')) {
				if (type === 'single' && startDate) {
					// Для single-режима триггерим сразу после выбора даты
					const changeEvent = new Event('change', { bubbles: true });
					valInputEl.dispatchEvent(changeEvent);
				} else if (type === 'range' && startDate && endDate) {
					// Для range-режима триггерим только после выбора обеих дат
					const changeEvent = new Event('change', { bubbles: true });
					valInputEl.dispatchEvent(changeEvent);
				}
			}

			// Закрываем календарь после завершения выбора
			if (type === 'single' && startDate) {
				// Для single-режима закрываем сразу после выбора даты
				calendar.classList.remove('active');
			} else if (type === 'range' && startDate && endDate) {
				// Для range-режима закрываем только после выбора обеих дат
				calendar.classList.remove('active');
			}
		}

		function clearSelection() {
			monthList.querySelectorAll('.datepicker-calendar__day-btn')
				.forEach(btn => btn.classList.remove('day-start', 'day-end', 'day-inside'));
		}

		function updateRangeClasses() {
			clearSelection();
			if (!startDate) return;
			monthList.querySelectorAll('.datepicker-calendar__day-btn').forEach(btn => {
				const d = dateFromBtn(btn);
				if (d.getTime() === startDate.getTime()) btn.classList.add('day-start');
				if (endDate && d.getTime() === endDate.getTime()) btn.classList.add('day-end');
				if (startDate && endDate && d > startDate && d < endDate)
					btn.classList.add('day-inside');
			});
		}

		function updateHeaderValues() {
			if (btnStart) {
				valStartEl.textContent = startDate ? fmtHeaderRU_SG.format(startDate) : placeholderStart;
				// В режиме range НЕ добавляем ready для start (кнопка reset только у end)
				if (type !== 'range') {
					btnStart.classList.toggle('ready', !!startDate);
				}
			}
			if (type === 'range' && btnEnd) {
				valEndEl.textContent = endDate ? fmtHeaderRU_SG.format(endDate) : placeholderEnd;
				// ready добавляем только когда выбраны ОБЕ даты
				btnEnd.classList.toggle('ready', !!(startDate && endDate));
			}
			if (nightsEl) {
				if (startDate && endDate) {
					const diff = Math.round((endDate - startDate) / (1000 * 60 * 60 * 24));
					let end;
					if (diff % 10 == 1 && diff % 100 != 11)
						end = 'ь';
					else if ((diff % 10 > 1 && diff % 10 < 5) && (diff % 100 < 11 || diff % 100 > 15))
						end = 'и';
					else
						end = 'ей';
					nightsValueEl.textContent = diff + ' ноч' + end;

					nightsEl.classList.add('active');
				} else {
					nightsEl.classList.remove('active');
				}
			}

			valInputEl.value = toSingaporeDateString(startDate) + (type === 'range' && btnEnd ? ' - ' + toSingaporeDateString(endDate) : '');

			// Очищаем ошибку валидации при выборе даты (закомментировано)
			// if (startDate) {
			// 	const formItem = picker.closest('.form__item');
			// 	const mistakeEl = formItem ? formItem.querySelector('.form__item-mistake') : null;
			// 	if (mistakeEl) {
			// 		mistakeEl.textContent = '';
			// 		mistakeEl.style.display = 'none';
			// 	}
			// }

			// Триггер обновления для Hotels компонента при выборе обеих дат в range picker
			if (type === 'range' && startDate && endDate && typeof window.hotels !== 'undefined') {
				// Проверяем, что это датапикер отелей (есть класс hotels-settings-datepicker)
				if (picker.classList.contains('hotels-settings-datepicker')) {
					console.log('[Datepicker] Hotels range selected, triggering update');
					// Создаем искусственное событие change для input
					const changeEvent = new Event('change', { bubbles: true });
					valInputEl.dispatchEvent(changeEvent);
				}
			}
		}

		// only add reset handlers if element exists
		resetStart?.addEventListener('click', () => {
			startDate = endDate = null;
			syncDataAttrs();
			clearSelection();
			updateHeaderValues();

			// Триггер обновления для Hotels при сбросе дат
			if (picker.classList.contains('hotels-settings-datepicker') && typeof window.hotels !== 'undefined') {
				console.log('[Datepicker] Hotels dates reset, triggering update');
				const changeEvent = new Event('change', { bubbles: true });
				valInputEl.dispatchEvent(changeEvent);
			}

			// Триггер для всех остальных datepicker'ов
			if (!picker.classList.contains('hotels-settings-datepicker')) {
				const changeEvent = new Event('change', { bubbles: true });
				valInputEl.dispatchEvent(changeEvent);
			}
		});
		resetEnd?.addEventListener('click', () => {
			// Сбрасываем весь диапазон (обе даты)
			startDate = endDate = null;
			syncDataAttrs();
			clearSelection();
			updateRangeClasses();
			updateHeaderValues();

			// Триггер обновления для Hotels при сбросе дат
			if (picker.classList.contains('hotels-settings-datepicker') && typeof window.hotels !== 'undefined') {
				console.log('[Datepicker] Hotels dates reset, triggering update');
				const changeEvent = new Event('change', { bubbles: true });
				valInputEl.dispatchEvent(changeEvent);
			}

			// Триггер для всех остальных datepicker'ов
			if (!picker.classList.contains('hotels-settings-datepicker')) {
				const changeEvent = new Event('change', { bubbles: true });
				valInputEl.dispatchEvent(changeEvent);
			}
		});

		// togglers
		btnStart?.addEventListener('click', () => calendar.classList.toggle('active'));
		btnEnd?.addEventListener('click', () => calendar.classList.toggle('active'));

		btnShowMore.addEventListener('click', e => {
			e.preventDefault();
			renderMonths(3);
		});

		// initial render
		renderMonths(3);
		updateHeaderValues();
		updateRangeClasses();
	});
}


/* === Guests Initialization === */
function initGuests(container = document) {
	const toggler = container.querySelector('.guests-picker__toggler');
	const popup = container.querySelector('.guests-picker__popup');
	const readyBtn = container.querySelector('.guests-picker__ready');
	const resetBtn = container.querySelector('.guests-picker__reset');
	const togglerValue = toggler?.querySelector('.guests-picker__toggler-value');
	const placeholder = toggler?.dataset.placeholder || '';
	const adultsInput = container.querySelector('.guests-picker__adults-input');
	const minusBtn = container.querySelector('.guests-picker__adults-minus');
	const plusBtn = container.querySelector('.guests-picker__adults-plus');
	const kidsList = container.querySelector('.guests-picker__kids-list');
	const addKidSelect = container.querySelector('select[name="kids_age"]');
	if (!toggler || !popup || !readyBtn || !resetBtn || !togglerValue || !adultsInput || !minusBtn || !plusBtn || !kidsList || !addKidSelect) return;

	// Проверка data-required атрибута на контейнере guests-picker
	const guestsPickerContainer = container.querySelector('.guests-picker');
	if (guestsPickerContainer?.dataset.required === 'true' && adultsInput) {
		adultsInput.setAttribute('required', 'required');
	}

	container.addEventListener('click', e => {
		const tgt = e.target;
		const isToggler = !!tgt.closest('.guests-picker__toggler');
		const isReset = !!tgt.closest('.guests-picker__reset');
		const isPopup = !!tgt.closest('.guests-picker__popup');
		if (!isToggler && !isReset && !isPopup) {
			popup.classList.remove('active');
			toggler.classList.remove('active');
		}
	});

	let adults = parseInt(adultsInput.value, 10);
	if (isNaN(adults)) adults = 0;
	adultsInput.value = adults;

	function updateSummary() {
		const numKids = kidsList.children.length;
		if (adults === 0 && numKids === 0) {
			togglerValue.textContent = placeholder;
			toggler.classList.remove('ready');
		} else {
			togglerValue.textContent = `${adults} взр. / ${numKids} дет.`;
			toggler.classList.add('ready');
		}
	}

	// Функция для привязки событий к существующим детям
	function bindExistingKidsEvents() {
		kidsList.querySelectorAll('.guests-picker__kids-item').forEach(item => {
			// Проверяем, не привязаны ли уже события
			if (item.hasAttribute('data-events-bound')) return;
			item.setAttribute('data-events-bound', 'true');

			// Привязываем change к селекту возраста
			const select = item.querySelector('select[name="children[]"]');
			if (select) {
				select.addEventListener('change', () => {
					updateSummary();
					// Триггерим change на adultsInput при изменении возраста ребенка
					const changeEvent = new Event('change', { bubbles: true });
					adultsInput.dispatchEvent(changeEvent);
				});
			}

			// Привязываем удаление
			const delBtn = item.querySelector('.guests-picker__kids-item-delete');
			if (delBtn) {
				delBtn.addEventListener('click', e => {
					e.stopPropagation();
					item.remove();
					updateSummary();
					// Триггерим change событие при удалении ребенка
					const changeEvent = new Event('change', { bubbles: true });
					adultsInput.dispatchEvent(changeEvent);
				});
			}
		});
	}

	toggler.addEventListener('click', () => {
		popup.classList.toggle('active');
		toggler.classList.toggle('active');
	});
	readyBtn.addEventListener('click', () => {
		popup.classList.remove('active');
		toggler.classList.remove('active');
	});
	resetBtn.addEventListener('click', () => {
		adults = 0;
		adultsInput.value = adults;
		kidsList.innerHTML = '';
		updateSummary();
		// Триггерим change событие
		const changeEvent = new Event('change', { bubbles: true });
		adultsInput.dispatchEvent(changeEvent);
	});
	minusBtn.addEventListener('click', () => {
		adults = Math.max(0, adults - 1);
		adultsInput.value = adults;
		updateSummary();
		// Триггерим change событие
		const changeEvent = new Event('change', { bubbles: true });
		adultsInput.dispatchEvent(changeEvent);
	});
	plusBtn.addEventListener('click', () => {
		adults += 1;
		adultsInput.value = adults;
		updateSummary();
		// Триггерим change событие
		const changeEvent = new Event('change', { bubbles: true });
		adultsInput.dispatchEvent(changeEvent);
	});
	adultsInput.addEventListener('input', () => {
		const v = parseInt(adultsInput.value, 10);
		adults = isNaN(v) ? 0 : v;
		adultsInput.value = adults;
		updateSummary();
		// Триггерим change событие
		const changeEvent = new Event('change', { bubbles: true });
		adultsInput.dispatchEvent(changeEvent);
	});

	addKidSelect.addEventListener('change', () => {
		const age = addKidSelect.value;
		if (age === '' && age !== '0') return;
		const li = document.createElement('li');
		li.className = 'guests-picker__kids-item';
		const select = document.createElement('select');
		select.className = 'form__select form__select--32 guests-picker__kids-item-select';
		for (let i = 0; i <= 17; i++) {
			const opt = document.createElement('option');
			opt.value = i;
			opt.textContent = i;
			if (String(i) === age) opt.selected = true;
			select.appendChild(opt);
		}
		select.name = "children[]";
		select.addEventListener('change', () => {
			updateSummary();
			// Триггерим change на adultsInput при изменении возраста ребенка
			const changeEvent = new Event('change', { bubbles: true });
			adultsInput.dispatchEvent(changeEvent);
		});
		const delBtn = document.createElement('button');
		delBtn.type = 'button';
		delBtn.className = 'btn btn--32 guests-picker__kids-item-delete';
		delBtn.innerHTML = '<span class="material-symbols-sharp">delete</span>';
		delBtn.addEventListener('click', e => {
			e.stopPropagation();
			li.remove();
			updateSummary();
			// Триггерим change событие при удалении ребенка
			const changeEvent = new Event('change', { bubbles: true });
			adultsInput.dispatchEvent(changeEvent);
		});
		li.append(select, delBtn);
		kidsList.appendChild(li);
		addKidSelect.value = '';
		updateSummary();
		// Триггерим change событие при добавлении ребенка
		const changeEvent = new Event('change', { bubbles: true });
		adultsInput.dispatchEvent(changeEvent);
	});

	// Привязываем события к уже существующим детям из XML
	bindExistingKidsEvents();

	updateSummary();
}


// service filters sections togglers
function initFiltersToggle() {
	const togglers = document.querySelectorAll('.service-filters__section-toggler');
	togglers.forEach(toggler => {
		toggler.addEventListener('click', () => {
			const section = toggler.closest('.service-filters__section');
			if (section) {
				section.classList.toggle('active');
			}
		});
	});
}


// popupManager.js
const PopupManager = (() => {
	// Стек имён открытых попапов
	const activeStack = [];

	function init() {
		bindOpenButtons();
		bindCloseButtons();
		bindDocumentClick();
		bindOverlayClick();
		bindEscapeKey();
	}

	// 1. Открытие/тогглинг попапов по кнопкам ([data-popup-open])
	function bindOpenButtons() {
		document.querySelectorAll('[data-popup-open]').forEach(btn => {
			btn.addEventListener('click', e => {
				const name = btn.getAttribute('data-popup-open');
				const insideFalse = btn.closest('[data-popup-close="false"]');
				const isOpen = activeStack.includes(name);

				// Если этот попап ещё не открыт и кнопка вне зоны data-popup-close="false" —
				// сначала закрываем все остальные
				if (!isOpen && !insideFalse) {
					closeAll();
				}

				toggle(name);
				// без stopPropagation, чтобы клик прошёл до document-click
			});
		});
	}

	// 2. Явные кнопки закрытия внутри попапа ([data-popup-close="true"])
	function bindCloseButtons() {
		document.querySelectorAll('.popup [data-popup-close="true"]').forEach(btn => {
			btn.addEventListener('click', e => {
				e.stopPropagation();
				const popup = btn.closest('.popup');
				if (!popup) return;
				close(popup.getAttribute('data-popup-name'));
			});
		});
	}

	// 3. Клик по документу: закрываем все попапы,
	//    кроме кликов по тогглерам уже открытых попапов и кликов внутри любого .popup
	function bindDocumentClick() {
		document.addEventListener('click', e => {
			// если кликнули по кнопке открытия открытого попапа — не закрываем
			const toggler = e.target.closest('[data-popup-open]');
			if (toggler && activeStack.includes(toggler.getAttribute('data-popup-open'))) {
				return;
			}
			// если кликнут внутри любого попапа — не закрываем
			if (e.target.closest('.popup')) {
				return;
			}
			closeAll();
		});
	}

	// 4. Клик по самому фону (.popup) — закрыть только этот попап,
	//    если клик не в зоне data-popup-close="false"
	function bindOverlayClick() {
		document.querySelectorAll('.popup').forEach(popup => {
			popup.addEventListener('click', e => {
				if (e.target !== popup) return;
				if (e.target.closest('[data-popup-close="false"]')) return;
				close(popup.getAttribute('data-popup-name'));
				e.stopPropagation();
			});
		});
	}

	// 5. Escape — закрыть все попапы
	function bindEscapeKey() {
		document.addEventListener('keydown', e => {
			if (e.key === 'Escape') {
				e.preventDefault();
				closeAll();
			}
		});
	}

	function open(name) {
		console.log(`[PopupManager] Attempting to open popup: ${name}`);
		const popup = document.querySelector(`.popup[data-popup-name="${name}"]`);
		if (!popup) {
			console.error(`[PopupManager] Popup element not found: ${name}`);
			return;
		}
		if (activeStack.includes(name)) {
			console.log(`[PopupManager] Popup already open: ${name}`);
			return;
		}
		console.log(`[PopupManager] Opening popup: ${name}`);
		activeStack.push(name);
		popup.classList.add('active');
		if (activeStack.length === 1) {
			document.body.classList.add('no-scroll');
		}
		console.log(`[PopupManager] Popup opened successfully: ${name}`);
	}

	function close(name) {
		const idx = activeStack.lastIndexOf(name);
		if (idx === -1) return;
		activeStack.splice(idx, 1);
		const popup = document.querySelector(`.popup[data-popup-name="${name}"]`);
		if (popup) popup.classList.remove('active');
		if (activeStack.length === 0) {
			document.body.classList.remove('no-scroll');
		}
	}

	function closeAll() {
		// клонируем стек, чтобы не мутировать его во время итерации
		activeStack.slice().forEach(name => close(name));
	}

	function toggle(name) {
		if (activeStack.includes(name)) close(name);
		else open(name);
	}

	return { init, open, close, closeAll, toggle };
})();


// пример: если нужен программный вызов закрытия из формы
// PopupManager.close('название-попапа');


function initGuestsManager() {
	const listEl = document.querySelector('.guests-manager-guests__list');
	const addAdult = document.querySelector('.guests-manager-guests__add-adult');
	const kidsSel = document.querySelector('.guests-manager-guests__add-kids-select');
	const tpl = document.getElementById('guest-item-template')?.content;

	if (!listEl || !addAdult || !kidsSel || !tpl) {
		console.warn('initGuestsManager: не найдены необходимые элементы');
		return;
	}

	// Генерация нового элемента гостя из <template>
	function createGuestItem(age = '18+') {
		const item = tpl.querySelector('li').cloneNode(true);
		item.querySelectorAll('input.form__input').forEach(i => i.value = '');
		item.querySelector('select.guests-manager-guests__item-select').value = age;
		return item;
	}

	// Добавление взрослого
	addAdult.addEventListener('click', () => {
		listEl.appendChild(createGuestItem('18+'));
	});

	// Добавление ребёнка
	kidsSel.addEventListener('change', e => {
		const age = e.target.value;
		if (!age) return;
		listEl.appendChild(createGuestItem(age));
		e.target.value = '';
	});

	// Удаление гостя (с предотвращением всплытия)
	listEl.addEventListener('click', e => {
		const btn = e.target.closest('.guests-manager-guests__item-delete');
		if (!btn) return;
		e.stopPropagation(); // предотвращаем всплытие события дальше
		const li = btn.closest('li.guests-manager-guests__item');
		if (li) li.remove();
	});
}


/* === Excursions Cards === */
function initExcursionCards() {
	document.querySelectorAll('.excursion-card').forEach(card => {
		card.addEventListener('click', e => {
			if (e.target.closest('.excursion-card__add, .excursion-card__more')) return;
			card.classList.toggle('active');
		});
	});
}

// time pickers
function initTimePickers(container = document) {
	const timeForms = container.querySelectorAll('.form-time');
	let isClickingHourButton = false;

	timeForms.forEach(form => {
		const hourInput = form.querySelector('.form-time__input--hour');
		const minutesInput = form.querySelector('.form-time__input--min');
		const popup = form.querySelector('.form-time__popup');
		const hourBtns = popup.querySelectorAll('.form-time__choice-btn--hour');
		const minBtns = popup.querySelectorAll('.form-time__choice-btn--min');
		const hourList = popup.querySelector('.form-time__choice-list:has(.form-time__choice-btn--hour)');
		const minList = popup.querySelector('.form-time__choice-list:has(.form-time__choice-btn--min)');

		// Сохраняем исходные значения при открытии popup
		let initialHourValue = '';
		let initialMinutesValue = '';

		// Функция для обновления активных классов
		const updateActiveButtons = () => {
			// Обновляем активную кнопку часов
			const hourValue = hourInput.value.trim();
			hourBtns.forEach(btn => {
				const btnValue = btn.textContent.trim().padStart(2, '0');
				// Только если есть значение в input, иначе не выделяем ничего
				const isActive = hourValue && btnValue === hourValue.padStart(2, '0');
				btn.classList.toggle('active', isActive);
			});

			// Обновляем активную кнопку минут
			const minValue = minutesInput.value.trim();
			minBtns.forEach(btn => {
				const btnValue = btn.textContent.trim().padStart(2, '0');
				// Только если есть значение в input, иначе не выделяем ничего
				const isActive = minValue && btnValue === minValue.padStart(2, '0');
				btn.classList.toggle('active', isActive);
			});
		};

		// Функция для прокрутки списка к выбранному времени
		const scrollToTime = () => {
			// Прокрутка часов
			const currentHour = hourInput.value || '12';
			const hourBtn = Array.from(hourBtns).find(btn => btn.textContent.trim() === currentHour);
			if (hourBtn && hourList) {
				const listRect = hourList.getBoundingClientRect();
				const btnRect = hourBtn.getBoundingClientRect();
				const scrollTop = btnRect.top - listRect.top + hourList.scrollTop - (listRect.height / 2) + (btnRect.height / 2);
				hourList.scrollTop = scrollTop;
			}

			// Прокрутка минут
			const currentMin = minutesInput.value || '00';
			const minBtn = Array.from(minBtns).find(btn => btn.textContent.trim() === currentMin);
			if (minBtn && minList) {
				const listRect = minList.getBoundingClientRect();
				const btnRect = minBtn.getBoundingClientRect();
				const scrollTop = btnRect.top - listRect.top + minList.scrollTop - (listRect.height / 2) + (btnRect.height / 2);
				minList.scrollTop = scrollTop;
			}
		};

		const showPopup = () => {
			popup.classList.add('active');
			// Сохраняем текущие значения
			initialHourValue = hourInput.value;
			initialMinutesValue = minutesInput.value;
			// Обновляем активные кнопки и прокручиваем к выбранному времени после открытия
			setTimeout(() => {
				updateActiveButtons();
				scrollToTime();
			}, 0);
		};

		const hidePopup = () => {
			popup.classList.remove('active');
			// Проверяем, изменились ли значения
			const hourChanged = hourInput.value !== initialHourValue;
			const minutesChanged = minutesInput.value !== initialMinutesValue;

			// Триггерим change события если значения изменились
			if (hourChanged) {
				const changeEvent = new Event('change', { bubbles: true });
				hourInput.dispatchEvent(changeEvent);
			}
			if (minutesChanged) {
				const changeEvent = new Event('change', { bubbles: true });
				minutesInput.dispatchEvent(changeEvent);
			}
		};

		const correctValue = (input, max) => {
			let v = parseInt(input.value, 10);
			if (isNaN(v)) v = 0;
			v = Math.max(0, Math.min(v, max));
			input.value = String(v).padStart(2, '0');
		};

		const restrictInput = (input, max) => {
			input.addEventListener('input', () => {
				input.value = input.value.replace(/\D/g, '').slice(0, 2);
				if (input.value.length === 2) {
					correctValue(input, max);
					updateActiveButtons(); // Обновляем активные классы при вводе
					if (input === hourInput) {
						minutesInput.focus(); showPopup();
					} else {
						hidePopup(); input.blur();
					}
				}
			});
			input.addEventListener('blur', () => {
				correctValue(input, max);
				updateActiveButtons(); // Обновляем активные классы при blur
				setTimeout(() => {
					if (!isClickingHourButton &&
						!hourInput.matches(':focus') &&
						!minutesInput.matches(':focus')) {
						hidePopup();
					}
				}, 200);
			});
		};

		restrictInput(hourInput, 23);
		restrictInput(minutesInput, 59);

		[hourInput, minutesInput].forEach(input => {
			input.addEventListener('focus', () => {
				setTimeout(() => input.select(), 0);
				showPopup();
			});
		});

		hourBtns.forEach(btn => {
			btn.addEventListener('mousedown', () => isClickingHourButton = true);
			btn.addEventListener('click', () => {
				hourInput.value = btn.textContent.trim().padStart(2, '0');
				updateActiveButtons(); // Обновляем активные классы
				minutesInput.focus();
				isClickingHourButton = false;
				// Не триггерим change здесь, так как пользователь еще не закрыл popup
			});
		});

		minBtns.forEach(btn => {
			btn.addEventListener('click', () => {
				minutesInput.value = btn.textContent.trim().padStart(2, '0');
				updateActiveButtons(); // Обновляем активные классы
				if (!hourInput.value) hourInput.focus();
				else {
					hidePopup(); // hidePopup сам вызовет dispatchEvent если значения изменились
					minutesInput.blur();
				}
			});
		});
	});

	// Общий сброс флага клика по hour-кнопкам
	container.addEventListener('click', e => {
		if (!e.target.closest('.form-time__choice-btn--hour')) {
			isClickingHourButton = false;
		}
	});
}


// Form multi
function initFormMulti(container = document) {
	const forms = container.querySelectorAll('.form-multi');

	forms.forEach(form => {
		const topInput = form.querySelector('.form-multi__top-input');
		const choiceContainer = form.querySelector('.form-multi__choice');
		const choiceItems = form.querySelectorAll('.form-multi__choice-item');
		const choiceLabels = form.querySelectorAll('.form-multi__choice-label');
		const choiceInputs = form.querySelectorAll('.form-multi__choice-input');

		// Определяем режим: если есть атрибут data-allow-custom="true", разрешаем свободный ввод
		const allowCustom = form.dataset.allowCustom === 'true';

		// Сохраняем изначальное значение для сброса при пустом поиске
		let selectedValue = topInput.value;
		let selectedLabel = topInput.value;

		// Предотвращаем закрытие при клике по контейнеру выбора
		if (choiceContainer) {
			choiceContainer.addEventListener('mousedown', (e) => {
				// Если клик не по label (элементу выбора), предотвращаем blur
				if (!e.target.closest('.form-multi__choice-label')) {
					e.preventDefault();
				}
			});
		}

		if (topInput) {
			// Открытие списка при фокусе
			topInput.addEventListener('focus', () => {
				// Закрываем все открытые
				forms.forEach(f => f.classList.remove('active'));

				// Открываем текущий
				form.classList.add('active');

				// Показываем все элементы при открытии
				choiceItems.forEach(item => item.style.display = '');
			});

			// Поиск при вводе текста
			topInput.addEventListener('input', () => {
				const searchText = topInput.value.toLowerCase().trim();
				let hasVisibleItems = false;

				choiceItems.forEach((item, index) => {
					const label = choiceLabels[index];
					const labelText = label ? label.textContent.toLowerCase().trim() : '';

					if (labelText.includes(searchText)) {
						item.style.display = '';
						hasVisibleItems = true;
					} else {
						item.style.display = 'none';
					}
				});

				// Если ничего не найдено и не разрешен свободный ввод, можно показать сообщение
				// Но пока просто скрываем все несовпадающие элементы
			});

			// Обработка потери фокуса
			topInput.addEventListener('blur', () => {
				setTimeout(() => {
					// Проверяем, не кликнули ли мы по элементу списка
					if (!form.contains(document.activeElement)) {
						// Если не разрешен свободный ввод и ничего не выбрано
						if (!allowCustom) {
							// Если текущее значение не совпадает с выбранным, возвращаем выбранное
							const currentText = topInput.value.toLowerCase().trim();
							const matchedLabel = Array.from(choiceLabels).find(
								label => label.textContent.toLowerCase().trim() === currentText
							);

							if (!matchedLabel) {
								// Возвращаем предыдущее выбранное значение
								topInput.value = selectedLabel;
							}
						}
						// Если разрешен свободный ввод, оставляем введенное значение как есть

						// Закрываем список
						form.classList.remove('active');
					}
				}, 150);
			});
		}

		// Обработка выбора элемента из списка
		choiceLabels.forEach((label, index) => {
			label.addEventListener('click', (e) => {
				e.preventDefault();

				const input = choiceInputs[index];
				const labelText = label.textContent.trim();
				const inputValue = input ? input.value : labelText;

				// Устанавливаем значение в текстовое поле
				topInput.value = labelText;

				// Сохраняем выбранные значения
				selectedValue = inputValue;
				selectedLabel = labelText;

				// Отмечаем radio input как выбранный
				if (input) {
					input.checked = true;
				}

				// Если есть скрытый input рядом с topInput, обновляем его значение
				const hiddenInput = form.querySelector('input[type="hidden"]');
				if (hiddenInput) {
					hiddenInput.value = inputValue;
					console.log('[FormMulti] Hidden input updated:', inputValue);
				}

				// Очищаем ошибку валидации при выборе значения
				// const formItem = form.closest('.form__item');
				// const mistakeEl = formItem ? formItem.querySelector('.form__item-mistake') : null;
				// if (mistakeEl) {
				// 	mistakeEl.textContent = '';
				// 	mistakeEl.style.display = 'none';
				// }
				if (topInput) {
					topInput.setCustomValidity('');
				}

				// Закрываем список
				form.classList.remove('active');

				// Триггерим событие change
				const changeEvent = new Event('change', { bubbles: true });
				topInput.dispatchEvent(changeEvent);
			});
		});
	});

	// Клик вне .form-multi — закрываем все
	container.addEventListener('click', e => {
		if (!e.target.closest('.form-multi')) {
			forms.forEach(form => {
				form.classList.remove('active');
			});
		}
	});
}

//
function setupCipTypeSwitcher() {
	const inputs = document.querySelectorAll('.form-choice-btn__input[name="cip_type"]');
	const fieldContainers = document.querySelectorAll('.cip__fields-type');

	function updateFields() {
		const checked = document.querySelector('.form-choice-btn__input[name="cip_type"]:checked');
		const selectedType = checked ? checked.id.replace('cip_type_', '') : null;

		fieldContainers.forEach(container => {
			const type = container.getAttribute('data-cip-fields');
			let isActive;

			if (selectedType === 'round') {
				// при round показываем и arrival, и departure
				isActive = (type === 'arrival' || type === 'departure');
			} else {
				// при arrival показываем только arrival, при departure — только departure
				isActive = (type === selectedType);
			}

			container.classList.toggle('active', isActive);
			// блокируем все вложенные поля, если неактивен
			container.querySelectorAll('input, select, textarea, button').forEach(control => {
				control.disabled = !isActive;
			});
		});
	}

	inputs.forEach(input => {
		input.addEventListener('change', updateFields);
	});

	// начальная инициализация при загрузке
	updateFields();
}

function initCounters(container = document) {
	// Находим все блоки-счётчики
	const counters = container.querySelectorAll('.form__counter');

	counters.forEach(counter => {
		const input = counter.querySelector('.form__counter-input');
		const btnMinus = counter.querySelector('.form__counter-btn--minus');
		const btnPlus = counter.querySelector('.form__counter-btn--plus');

		// Ограничиваем ввод только цифрами
		input.addEventListener('input', e => {
			// Убираем всё, что не цифры
			e.target.value = e.target.value.replace(/\D/g, '');
		});

		// Декремент
		btnMinus.addEventListener('click', () => {
			let value = parseInt(input.value, 10);
			if (isNaN(value)) value = 0;
			value = value - 1;
			// Не опускать ниже нуля (если нужно)
			if (value < 0) value = 0;
			input.value = value;
			$(input).trigger('change');
		});

		// Инкремент
		btnPlus.addEventListener('click', () => {
			let value = parseInt(input.value, 10);
			if (isNaN(value)) value = 0;
			input.value = value + 1;
			$(input).trigger('change');
		});
	});
}

function initOrderSectionToggleChecks(root = document) {
	// Для каждой секции "Отели / Трансферы / Экскурсии / Виза / VIP"
	root.querySelectorAll('.order-section').forEach(section => {
		const thBtn = section.querySelector('.order-section__th-check');
		if (!thBtn) return;

		// Обновление состояния кнопки (опционально — класс для стилизации)
		const syncHeaderBtn = () => {
			const inputs = section.querySelectorAll('.order-cell__check-input');
			if (!inputs.length) return thBtn.classList.remove('is-active');
			const allChecked = [...inputs].every(i => i.checked || i.disabled);
			thBtn.classList.toggle('is-active', allChecked);
		};

		// Клик по "глазку" в шапке — выбрать/снять всё в пределах секции
		thBtn.addEventListener('click', (e) => {
			e.preventDefault();
			const inputs = section.querySelectorAll('.order-cell__check-input');
			if (!inputs.length) return;

			// Если есть хотя бы один НЕ отмеченный — отмечаем всё, иначе снимаем всё
			const shouldCheckAll = [...inputs].some(i => !i.checked && !i.disabled);

			inputs.forEach(i => {
				if (i.disabled) return;
				if (i.checked !== shouldCheckAll) {
					i.checked = shouldCheckAll;
					// Если где-то подписались на change — уведомим
					i.dispatchEvent(new Event('change', { bubbles: true }));
				}
			});

			syncHeaderBtn();
		});

		// Синхронизация состояния при старте
		syncHeaderBtn();

		// Если чекбоксы меняют состояние по одному — держим кнопку в актуальном виде
		section.addEventListener('change', (e) => {
			if (e.target && e.target.classList.contains('order-cell__check-input')) {
				syncHeaderBtn();
			}
		});
	});
}


// ===== helpers (общие) =====
function __ot_debounce(fn, wait = 100) {
	let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn.apply(null, args), wait); };
}
function __ot_rectNoTx(el) {
	const prev = el.style.transform;
	el.style.transform = '';
	const r = el.getBoundingClientRect();
	el.style.transform = prev;
	return r;
}
function __ot_setTxX(el, x) {
	el.style.transform = `translateX(${Math.round(x)}px)`;
}

// ========================= 1) OPEN/CLOSE ONLY =========================
function initOrdersTooltipsOpenCloseOnly() {
	const WRAP = '.orders-tooltip';
	const TOGGLER = '.orders-tooltip__toggler';
	const PANEL = '.orders-tooltip__tooltip';
	const isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;

	const wraps = Array.from(document.querySelectorAll(WRAP));

	const closeWrap = (wrap) => {
		const toggler = wrap.querySelector(TOGGLER);
		const panel = wrap.querySelector(PANEL);
		if (toggler) toggler.classList.remove('active');
		if (panel) panel.classList.remove('active');
	};

	const closeAll = (except = null) => {
		wraps.forEach(w => { if (w !== except) closeWrap(w); });
	};

	if (isTouch) {
		// Мобилка: по клику
		wraps.forEach(wrap => {
			const toggler = wrap.querySelector(TOGGLER);
			const panel = wrap.querySelector(PANEL);
			if (!toggler || !panel) return;

			toggler.addEventListener('click', (e) => {
				e.stopPropagation();
				const willOpen = !toggler.classList.contains('active');
				closeAll(wrap);
				if (willOpen) {
					toggler.classList.add('active');
					panel.classList.add('active');
				} else {
					closeWrap(wrap);
				}
			}, { passive: true });
		});

		// Клик вне — закрыть всё
		document.addEventListener('click', (e) => {
			if (!e.target.closest(WRAP)) closeAll();
		});
	} else {
		// Десктоп: hover (+ клики)
		wraps.forEach(wrap => {
			const toggler = wrap.querySelector(TOGGLER);
			const panel = wrap.querySelector(PANEL);
			if (!toggler || !panel) return;

			let leaveTimer = null;

			const open = () => {
				clearTimeout(leaveTimer);
				closeAll(wrap);
				toggler.classList.add('active');
				panel.classList.add('active');
			};
			const scheduleClose = () => {
				clearTimeout(leaveTimer);
				leaveTimer = setTimeout(() => {
					toggler.classList.remove('active');
					panel.classList.remove('active');
				}, 120);
			};

			wrap.addEventListener('mouseenter', open);
			wrap.addEventListener('mouseleave', scheduleClose);

			toggler.addEventListener('click', (e) => {
				e.stopPropagation();
				const isOpen = panel.classList.contains('active');
				if (isOpen) {
					toggler.classList.remove('active');
					panel.classList.remove('active');
				} else {
					open();
				}
			});
		});

		// Клик вне — закрыть всё
		document.addEventListener('click', (e) => {
			if (!e.target.closest(WRAP)) {
				wraps.forEach(closeWrap);
			}
		});
	}

	// Esc — закрыть всё
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			wraps.forEach(closeWrap);
		}
	});
}

// ========================= 2) CLAMP ON LOAD/RESIZE =========================
// Зажимает КАЖДЫЙ тултип внутрь экрана (>=16px от краёв) и границ ближайшего контейнера .orders__table-container
function initOrdersTooltipsClampOnLoad() {
	const EDGE_VP = 16;
	const PANEL_SEL = '.orders-tooltip__tooltip';
	const CONTAINER_SEL = '.orders__table-container';

	const clampOne = (panel) => {
		if (!panel) return;

		// сброс transform перед расчётом
		panel.style.transform = '';
		const p = __ot_rectNoTx(panel);

		// ближайший контейнер; если нет — считаем контейнером весь вьюпорт
		const container = panel.closest(CONTAINER_SEL);
		const c = container ? container.getBoundingClientRect() : { left: 0, right: window.innerWidth };

		// пределы по вьюпорту (с EDGE) и по контейнеру (без отступов)
		const minLeft = Math.max(EDGE_VP, c.left);
		const maxLeft = Math.min(window.innerWidth - EDGE_VP - p.width, c.right - p.width);

		// если контейнер уже, чем EDGE-рамки — прижимаем сколько можем
		const clampedLeft = Math.max(minLeft, Math.min(maxLeft, p.left));
		const dx = clampedLeft - p.left;

		if (dx) __ot_setTxX(panel, dx);
	};

	const clampAll = () => {
		document.querySelectorAll(PANEL_SEL).forEach(clampOne);
	};

	const runNowAndNextFrames = () => {
		clampAll();
		requestAnimationFrame(() => {
			clampAll();
			requestAnimationFrame(clampAll);
		});
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', runNowAndNextFrames, { once: true });
	} else {
		runNowAndNextFrames();
	}

	window.addEventListener('resize', __ot_debounce(clampAll, 100));

	// Если тултипы добавляются динамически — тоже клампим
	const mo = new MutationObserver(() => clampAll());
	mo.observe(document.body, { childList: true, subtree: true });
}

// ========================= 3) FOLLOW ON CONTAINER SCROLL =========================
// Активный тултип «следует» за левым краем своего тогглера, НО не выходит за границы контейнера
function initOrdersTooltipsFollowContainer() {
	const WRAP_SEL = '.orders-tooltip';
	const TOGGLER_SEL = '.orders-tooltip__toggler';
	const PANEL_SEL = '.orders-tooltip__tooltip';
	const CONTAINER_SEL = '.orders__table-container';

	const allWraps = Array.from(document.querySelectorAll(WRAP_SEL));

	function positionActiveWithinContainer(wrap) {
		const toggler = wrap.querySelector(TOGGLER_SEL);
		const panel = wrap.querySelector(PANEL_SEL);
		const container = wrap.closest(CONTAINER_SEL);
		if (!toggler || !panel) return;
		if (!(panel.classList.contains('active') || toggler.classList.contains('active'))) return;

		const tRect = toggler.getBoundingClientRect();
		const pRect0 = __ot_rectNoTx(panel);
		const cRect = container ? container.getBoundingClientRect() : { left: 0, right: window.innerWidth };

		// желаем левый край = левому краю тогглера
		let desiredLeft = tRect.left;

		// зажим в границы контейнера (без внутренних отступов)
		const minLeft = cRect.left;
		const maxLeft = cRect.right - pRect0.width;
		if (desiredLeft < minLeft) desiredLeft = minLeft;
		if (desiredLeft > maxLeft) desiredLeft = maxLeft;

		const shift = desiredLeft - pRect0.left;
		__ot_setTxX(panel, shift);
	}

	// группируем по контейнерам, чтобы на их скролле дергать только «свои» тултипы
	const byContainer = new Map(); // containerEl|null -> Set<wrap>
	allWraps.forEach(wrap => {
		const container = wrap.closest(CONTAINER_SEL);
		const key = container || document.documentElement;
		if (!byContainer.has(key)) byContainer.set(key, new Set());
		byContainer.get(key).add(wrap);
	});

	const handleContainerScroll = (containerEl) => {
		const wraps = byContainer.get(containerEl);
		if (!wraps) return;
		wraps.forEach(positionActiveWithinContainer);
	};

	const deb16 = __ot_debounce(() => { }, 16); // создадим отдельные замыкания
	byContainer.forEach((_wraps, containerEl) => {
		const handler = __ot_debounce(() => handleContainerScroll(containerEl), 16);
		if (containerEl === document.documentElement) {
			window.addEventListener('scroll', handler, { passive: true });
		} else {
			containerEl.addEventListener('scroll', handler, { passive: true });
		}
	});

	// ресайз — тоже обновим активные
	window.addEventListener('resize', __ot_debounce(() => {
		byContainer.forEach((_wraps, containerEl) => handleContainerScroll(containerEl));
	}, 100));

	// первичная установка (если что-то активно стилями)
	byContainer.forEach((_wraps, containerEl) => handleContainerScroll(containerEl));
}


//
function initOrderMarkupControls() {
	const form = document.querySelector('.order-calc-markup__control');
	const ownBlock = document.querySelector('.order-calc-markup__control-own');
	const ownRadio = document.getElementById('order_markup_own');
	const radios = document.querySelectorAll('.order-calc-markup__control-input');

	if (!ownBlock || !ownRadio || !radios.length) return;

	const update = () => {
		ownBlock.classList.toggle('active', ownRadio.checked);
		if (ownRadio.checked) {
			$(ownBlock).find('input').prop('disabled', false);
		}
		else {
			$(ownBlock).find('input').prop('disabled', true);
		}
	};

	// слушаем только нужные радио (без делегирования, без внешнего цикла по блокам)
	radios.forEach(r => r.addEventListener('change', update));

	// первичная установка
	update();
}


function setupVisaQuestionToggles(root = document) {
	const questions = root.querySelectorAll('.visa-applications-form__question');

	const updateQuestion = (questionEl) => {
		const more = questionEl.querySelector('.visa-applications-form__question-more');
		if (!more) return;

		const yesChecked = !!questionEl.querySelector('.visa-applications-form__question-input--yes:checked');

		// Тогглим .active на блоке "more"
		more.classList.toggle('active', yesChecked);

		// Заодно включаем/выключаем внутренние поля
		more.querySelectorAll('input, textarea, select').forEach((ctrl) => {
			ctrl.disabled = !yesChecked;
			// Если скрываем — снимаем значения у чекбоксов/радио
			if (!yesChecked && (ctrl.type === 'checkbox' || ctrl.type === 'radio')) {
				ctrl.checked = false;
			}
		});
	};

	// Инициализация и навешивание обработчиков
	questions.forEach((q) => {
		// Первичная инициализация состояния
		updateQuestion(q);

		// Слушаем change на всех радио внутри вопроса
		q.querySelectorAll('.visa-applications-form__question-input').forEach((input) => {
			input.addEventListener('change', () => updateQuestion(q));
		});
	});
}

function showInstantPopup() {
	if ($('.order').attr('data-open_popup-table')) {
		serviceManager.loadBlock($('.order').attr('data-open_popup-table'), $('.order').attr('data-open_popup-block_id'))
	}
	if ($('.order').attr('data-open_popup-payment')) {
		popupManager.open('popup-order-pay');
	}
}

let excursionSlider = new Swiper((".excursion-slider"), {
	modules: [EffectFade, Navigation],
	loop: true,
	effect: 'fade',
	fadeEffect: {
		crossFade: true,
	},
	navigation: {
		nextEl: '.excursion__gallery-nav-btn--next',
		prevEl: '.excursion__gallery-nav-btn--prev'
	}
});

let popupCarThumbs = new Swiper((".popup-car-gallery__thumbs"), {
	spaceBetween: 8,
	slidesPerView: 5,
	watchSlidesProgress: true,
});
let popupCarSlider = new Swiper((".popup-car-gallery__main"), {
	modules: [Thumbs, EffectFade],
	spaceBetween: 8,
	effect: 'fade',
	fadeEffect: {
		crossFade: true
	},
	thumbs: {
		swiper: popupCarThumbs,
		autoScrollOffset: 1,
	},
});

// Функция для инициализации галереи автомобиля в контейнере
function initCarGallery(container = document) {
	const mainGallery = container.querySelector('.popup-car-gallery__main');
	const thumbsGallery = container.querySelector('.popup-car-gallery__thumbs');

	if (!mainGallery || !thumbsGallery) return;

	// Уничтожаем старые экземпляры Swiper, если они есть
	if (mainGallery.swiper) {
		mainGallery.swiper.destroy(true, true);
	}
	if (thumbsGallery.swiper) {
		thumbsGallery.swiper.destroy(true, true);
	}

	// Создаем новые экземпляры Swiper
	const thumbsSwiper = new Swiper(thumbsGallery, {
		spaceBetween: 8,
		slidesPerView: 5,
		watchSlidesProgress: true,
	});

	const mainSwiper = new Swiper(mainGallery, {
		modules: [Thumbs, EffectFade],
		spaceBetween: 8,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		thumbs: {
			swiper: thumbsSwiper,
			autoScrollOffset: 1,
		},
	});
}

let popupAssistantThumbs = new Swiper((".popup-assistant-gallery__thumbs"), {
	spaceBetween: 8,
	slidesPerView: 5,
	watchSlidesProgress: true,
});
let popupAssistantSlider = new Swiper((".popup-assistant-gallery__main"), {
	modules: [Thumbs, EffectFade],
	spaceBetween: 8,
	effect: 'fade',
	fadeEffect: {
		crossFade: true
	},
	thumbs: {
		swiper: popupAssistantThumbs,
		autoScrollOffset: 1,
	},
});


// PASSWORD TOGGLER
function initPasswordTogglers() {
	const containers = document.querySelectorAll('.form__pass-input-container');

	containers.forEach(container => {
		const input = container.querySelector('.form__pass-input');
		const btn = container.querySelector('.form__pass-input-toggler');

		if (!input || !btn) return;

		btn.addEventListener('click', () => {
			btn.classList.toggle('active');
			input.type = input.type === 'password' ? 'text' : 'password';
		});
	});
}



// Main App Init
function initApp() {
	setAppSizes();
	applyTouchClass();
	initCookiePolicy();
	initHeaderNav();
	initClock();
	initCRMNav();
	initCartMenu();
	initTabs();
	initNumberDropdown();
	initHotelAndRoomCards();
	initExcursionCards();
	initDatepickers();

	initPasswordTogglers();


	initOrdersTooltipsOpenCloseOnly();  // поведение открытия/закрытия
	initOrdersTooltipsClampOnLoad();    // на старте (и при ресайзе) сдвигаем тултипы внутрь экрана/контейнера
	initOrdersTooltipsFollowContainer(); // активные тултипы следуют за тогглером при скролле контейнера

	initOrderMarkupControls();
	setupVisaQuestionToggles();

	// Инициализируем компоненты специфичные для страниц
	initPageSpecificComponents();
	initTimePickers();
	initFormMulti();
	initGuests();
	initFiltersToggle();
	initOrderSectionToggleChecks();
	popupManager.init(); // Инициализируем все попапы на странице
	initGuestsManager();
	setupCipTypeSwitcher();
	initCounters();

	showInstantPopup();
}

document.addEventListener('DOMContentLoaded', initApp);
window.addEventListener('resize', setAppSizes);
window.addEventListener('scroll', setAppSizes);

export {
	initApp,
	popupManager,
	initDatepickers,
	initGuests,
	initTimePickers,
	initFormMulti,
	initCounters,
	initHotelAndRoomCards,
	initTabs,
	initNumberDropdown,
	initOrderMarkupControls,
	initCarGallery
};
